module.exports = "/_next/static/images/logo-white512-f229b969b89514f44b7b7786d1bf2cde.png";